<template>
  <div class="flex flex-col space-y-2">
    <lf-h4>
      {{
        $t("ORGANIZATION.COMMUNICATION_TEMPLATES.ENTER_APP_TRACKING_TOKEN_LINK")
      }}
    </lf-h4>
    <div class="flex max-h-30 flex-col space-y-2 overflow-y-auto">
      <div
        v-for="({ value, id }, index) in inputs"
        :key="id"
        class="flex gap-x-2"
      >
        <input
          ref="inputBlock"
          :value="value"
          name="value"
          :data-cy="`app-token-value-${index}`"
          class="grow rounded-sm border border-gray-200 text-sm placeholder-gray-400 hover:border-gray-300 focus:border-primary focus:ring-0 focus:outline-hidden"
          :placeholder="$t('COMMON.TOKEN')"
          @input="updateInputValue($event, id)"
        />
        <div class="min-w-20">
          <div v-if="!!value" class="flex items-center gap-x-2">
            <div class="min-w-8">
              <button
                v-if="index"
                v-tooltip="`${$t('COMMON.DELETE')} ${$t('COMMON.TOKEN')}`"
                type="button"
                :data-cy="`app-delete-token-value-${index}`"
                class="w-fit-content justify-self-end rounded-4 p-2"
                @click="deleteInput(id)"
              >
                <icon-base :icon="IconDelete" />
              </button>
            </div>
            <button
              v-if="index === inputs.length - 1"
              v-tooltip="`${$t('COMMON.ADD')} ${$t('COMMON.TOKEN')}`"
              type="button"
              :data-cy="`app-add-token-value-${index}`"
              class="w-fit-content justify-self-end rounded-4 p-2"
              @click="addInput"
            >
              <icon-base :icon="IconAdd" :width="20" :height="20" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";

import { v4 } from "uuid";

import IconDelete from "@/components/icons/IconDelete.vue";
import IconAdd from "@/components/icons/deals/IconAdd.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfH4 from "@/components/ui/text/LfHeading4.vue";

const { initialValues } = defineProps<{
  initialValues?: string[];
}>();

const emit = defineEmits<{
  "value:change": [{ value: string; id: string }[]];
}>();

const inputBlock = ref<HTMLInputElement[] | null>(null);

const buildInitialInputs = () => {
  if (initialValues?.length) {
    return initialValues.map((value) => ({ value, id: v4() }));
  }
  return [{ value: "", id: v4() }];
};

const inputs = ref<{ value: string; id: string }[]>(buildInitialInputs());

const addInput = () => {
  inputs.value.push({ value: "", id: v4() });
  nextTick(() => {
    inputBlock.value?.[inputBlock.value.length - 1]?.focus();
  });
  emit("value:change", inputs.value);
};

const deleteInput = (id: string) => {
  const index = inputs.value.findIndex((input) => input.id === id);

  if (index === -1) {
    return;
  }

  inputs.value.splice(index, 1);
  emit("value:change", inputs.value);
};

const updateInputValue = (event: Event, id: string) => {
  const value = (event.target as HTMLInputElement).value;
  const index = inputs.value.findIndex((input) => input.id === id);

  if (index === -1) {
    return;
  }

  inputs.value[index].value = value;
  emit("value:change", inputs.value);
};

onMounted(() => {
  if (initialValues?.length) {
    emit("value:change", inputs.value);
  }
  inputBlock.value?.[0]?.focus();
});
</script>
